// Основано на react-leaflet-multi-options-polyline, с защитой от пустых и некорректных данных.
import { getBounds as geolibGetBounds } from 'geolib';
import Leaflet from 'leaflet';
import React from 'react';
import { FeatureGroup, Polyline } from 'react-leaflet';
class MapLeafletMultiColorsPolyline extends React.Component {
    constructor(props) {
        super(props);
        this.mapPositions = this.mapPositions.bind(this);
        this.state = {
            lines: this.mapPositions(),
        };
        this.getBounds = this.getBounds.bind(this);
    }
    mapPositions() {
        const { positions, optionIdxFn, options } = this.props;
        // Защита от пустых или некорректных данных
        if (!positions || !Array.isArray(positions) || positions.length < 2 || !options || !options.length) {
            return options && options.length
                ? options.map(function () {
                    return [];
                })
                : [];
        }
        const lines = new Array(options.length);
        const currentLine = new Array(options.length);
        for (let idx = 0; idx < options.length; ++idx) {
            currentLine[idx] = [];
            lines[idx] = [];
        }
        // Вспомогательная функция для безопасного получения индекса
        const safeIdx = function (idx) {
            // Ограничиваем индекс диапазоном [0, options.length - 1]
            return Math.max(0, Math.min(idx, options.length - 1));
        };
        let last;
        let lastLineIdx = 0;
        let currentLineIdx = 0;
        for (let _idx = 1; _idx < positions.length; ++_idx) {
            const item = positions[_idx];
            const previous = positions[_idx - 1];
            const coordinates = new Leaflet.LatLng(item[0], item[1]);
            currentLineIdx = safeIdx(optionIdxFn(item, previous, _idx, positions));
            currentLine[currentLineIdx].push(coordinates); // If 1st item, must handle item at index 0;
            if (_idx === 1) {
                last = previous;
                lastLineIdx = safeIdx(optionIdxFn(previous, previous, _idx - 1, positions));
                currentLine[lastLineIdx].push(last);
                if (lastLineIdx !== currentLineIdx) {
                    currentLine[lastLineIdx].push(coordinates);
                    lines[lastLineIdx].push(currentLine[lastLineIdx]);
                    currentLine[lastLineIdx] = [];
                }
            }
            else {
                // If the result of optionIdxFn from last is different from current, push last line and clear it;
                if (lastLineIdx !== currentLineIdx) {
                    currentLine[lastLineIdx].push(coordinates);
                    lines[lastLineIdx].push(currentLine[lastLineIdx]);
                    currentLine[lastLineIdx] = [];
                }
            } // Keep index and item
            lastLineIdx = currentLineIdx;
            last = item;
        } // Push last items;
        lines[currentLineIdx].push(currentLine[currentLineIdx]);
        return lines;
    }
    shouldComponentUpdate(nextProps) {
        return nextProps !== this.props;
    }
    componentDidUpdate() {
        this.setState({
            lines: this.mapPositions(),
        });
    }
    getBounds() {
        const bounds = geolibGetBounds(this.props.positions);
        return new Leaflet.LatLngBounds(new Leaflet.LatLng(bounds.maxLat, bounds.minLng), new Leaflet.LatLng(bounds.minLat, bounds.maxLng));
    }
    render() {
        return (React.createElement(FeatureGroup, null, this.state.lines.map((optionsLine, optionsIdx) => {
            return optionsLine.map((line, idx) => {
                return React.createElement(Polyline, Object.assign({ key: idx }, this.props, { positions: line }, this.props.options[optionsIdx]));
            });
        })));
    }
}
export default MapLeafletMultiColorsPolyline;
